import apiTrainingsTemplate from '@/api/trainings-template'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createTrainingTemplateStart:
    '[create training template] Create training template start',
  createTrainingTemplateSuccess:
    '[create training  template] Create training template success',
  createTrainingTemplateFailure:
    '[create training  template] Create training template failure'
}

export const actionTypes = {
  createTrainingTemplate: '[create training template] Create training template'
}

const mutations = {
  [mutationTypes.createTrainingTemplateStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createTrainingTemplateSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTrainingTemplateFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createTrainingTemplate](context, {template}) {
    context.commit(mutationTypes.createTrainingTemplateStart)
    return new Promise(resolve => {
      apiTrainingsTemplate
        .createTrainingTemplate(template)
        .then(response => {
          context.commit(mutationTypes.createTrainingTemplateSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createTrainingTemplateFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
